
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/traffic",
      function () {
        return require("private-next-pages/traffic.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/traffic"])
      });
    }
  